<p-table #ptable1 [value]="recordsList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         [showCurrentPageReport]="(totalRecords > 10)"
         [totalRecords]="totalRecords"
         [paginator]="(totalRecords > 10)"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} строк"
         sortMode="single"
         sortField="ci_odate"
         sortOrder="-1"
         dataKey="ci_orderid"
         selectionMode="single"
         [(selection)]="selectedRecord"
         (onRowSelect)="onRecentRowSelect($event)"
         rowExpandMode="single"
         [rowHover]="true"
         [resizableColumns]="true"
         stateStorage="local"
         stateKey="customerBalanceTable-state"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestoreNew($event)"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped"
         *ngIf="recordsList as rl">

  <!--
  ci_comment1 : ""
  ci_comment2 : ""
  ci_custid : 1377
  ci_details : ""
  ci_mansum : 0
  ci_odate : "2018-07-24T12:09:26.000Z"
  ci_onumber : "15201"
  ci_orderid : 74015
  ci_ordsum : 5948.25
  ci_paydate : "2018-08-06T09:32:21.000Z"
  ci_paysum : 5948.25
  ci_rsrsum : 0
  ci_shipsum : 5948.25
  ci_waysum : 0
    -->

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width: 3rem !important">...</th>
      <th pResizableColumn pSortableColumn="ci_odate" style="width: 10rem !important">Дата <p-sortIcon field="ci_odate"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_onumber" style="width: 12rem !important">Документ <p-sortIcon field="ci_onumber"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_ordsum" style="width: 10rem !important">Сумма <p-sortIcon field="ci_ordsum"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_paysum" style="width: 10rem !important">Оплачено <p-sortIcon field="ci_paysum"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_shipsum" style="width: 10rem !important">Отгружено <p-sortIcon field="ci_shipsum"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_rsrsum" style="width: 10rem !important">В резерве <p-sortIcon field="ci_rsrsum"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_waysum" style="width: 10rem !important">В пути <p-sortIcon field="ci_waysum"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_mansum" style="width: 10rem !important">В производстве <p-sortIcon field="ci_mansum"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_paydate" style="width: 10rem !important">Дата оплаты <p-sortIcon field="ci_paydate"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_comment1" style="width: auto">Примечание 1 <p-sortIcon field="ci_comment1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="ci_comment2" style="width: auto">Примечание 2 <p-sortIcon field="ci_comment2"></p-sortIcon></th>
    </tr>

    <tr>
      <th pResizableColumn style="width: 3rem !important">...</th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_odate']" (input)="ptable1.filter($event.target.value, 'ci_odate', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_onumber']" (input)="ptable1.filter($event.target.value, 'ci_onumber', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_ordsum']" (input)="ptable1.filter($event.target.value, 'ci_ordsum', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_paysum']" (input)="ptable1.filter($event.target.value, 'ci_paysum', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_shipsum']" (input)="ptable1.filter($event.target.value, 'ci_shipsum', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_rsrsum']" (input)="ptable1.filter($event.target.value, 'ci_rsrsum', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_waysum']" (input)="ptable1.filter($event.target.value, 'ci_waysum', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_mansum']" (input)="ptable1.filter($event.target.value, 'ci_mansum', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_paydate']" (input)="ptable1.filter($event.target.value, 'ci_paydate', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_comment1']" (input)="ptable1.filter($event.target.value, 'ci_comment1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['ci_comment2']" (input)="ptable1.filter($event.target.value, 'ci_comment2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rl let-expanded="expanded">
    <tr [pSelectableRow]="rl">
      <td>
        <button type="button" pButton pRipple [pRowToggler]="rl"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', 1, rl.ci_orderid]">{{rl.ci_odate | date:'dd.MM.yyyy' }}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', 1, rl.ci_orderid]">{{rl.ci_onumber}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{rl.ci_ordsum | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{rl.ci_paysum | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{rl.ci_shipsum | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{rl.ci_rsrsum | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{rl.ci_waysum |  number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{rl.ci_mansum |  number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{rl.ci_paydate | date:'dd.MM.yyyy' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{rl.ci_comment1}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{rl.ci_comment2}}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-rl>
    <tr>
      <td colspan="12">
        <div class="p-p-2">
          <app-document-content-table [selectedDocumentId]="rl.ci_orderid" [showFooterTotal]="true"></app-document-content-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td> </td>
      <td> </td>
      <td> </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalOrders | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalPayd | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalShipped | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalReserved | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalOnTheWay | number:'1.2-2'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalManufacture | number:'1.2-2'}}</td>
      <td> </td>
      <td> </td>
      <td> </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">
      Всего {{recordsList ? recordsList.length : 0 }} платежей на сумму {{totalPayd | number:'1.2-2'}}.
    </div>

    <div class="grid">
      <div class="col-12"></div>
      <div class="col-6">
      </div>
      <div class="col-6">
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="12">На сегодня документов нет</td>
    </tr>
  </ng-template>
</p-table>
